import $ from 'jquery';

class OverlayMenu {

  constructor() {
    this.openButton = $(".mars-header__menu-trigger");
    this.closeButton = $(".mars-header__menu-trigger.open");
    this.menuOverlay = $(".global-overlay-menu");
    this.isOverlayOpen = false;
    this.events();
    this.body = $('body');
  }

  events() {
    $(document).on('click', ".mars-header__menu-trigger", function () {
      if (!this.isOverlayOpen) {
        $(".global-overlay-menu").addClass("global-overlay-menu--active");
        $('body').addClass("body-no-scroll");
        $(".mars-header__menu-trigger").addClass("open");
        this.isOverlayOpen = true;
      } else {
        $(".global-overlay-menu").removeClass("global-overlay-menu--active");
        $('body').removeClass("body-no-scroll");
        $(".mars-header__menu-trigger").removeClass("open");
        this.isOverlayOpen = false;
      }
    }.bind(this));

    let e = $.Event('keydown');
    e.which = 13;
    $('.mars-header__menu-trigger').trigger(e);

    $(document).on("keydown", ".mars-header__menu-trigger", function (e) {
      if (e.keyCode === 13 && !this.isOverlayOpen) {
        if (!this.isOverlayOpen) {
          $(".global-overlay-menu").addClass("global-overlay-menu--active");
          $('body').addClass("body-no-scroll");
          $(".mars-header__menu-trigger").addClass("open");
          this.isOverlayOpen = true;
        }
      }

      if (e.keyCode === 27 && this.isOverlayOpen) {
        $(".global-overlay-menu").removeClass("global-overlay-menu--active");
        $('body').removeClass("body-no-scroll");
        $(".mars-header__menu-trigger").removeClass("open");
        this.isOverlayOpen = false;
      }
    });

    $(document).on("click", ".userInfo", function () {
      if ($(".userLoggedinPane").length) {
        if ($(".userInfo").hasClass('open')) {
          $(".userLoggedinPane").removeClass('active');
          $(".site-header__userRelatedMeta, .mars-header__util").removeClass('active');
          $(".userInfo").removeClass('open');
          $('body').removeClass("body-no-scroll");
          $('.popupModal__mask').fadeOut("fast", function () {
            $('.popupModal__mask').remove();
          });
        } else {
          $('.popupModal__mask').remove();
          $(".container--wide").prepend('<div class="popupModal__mask"></div>');
          $("body").addClass("body-no-scroll");
          $(".userLoggedinPane").addClass('active');
          $(".site-header__userRelatedMeta, .mars-header__util").addClass('active');
          $(".userInfo").addClass('open');
          this.isOverlayOpen = true;
        }
      }
    }.bind(this));

    $(window).on("click", function (e) {
      if (
        $(".userLoggedinPane").hasClass('active') &&
        !$(".userLoggedinPane").is(e.target) &&
        $(".userLoggedinPane").has(e.target).length == 0 &&
        !$(".initLogin").is(e.target) &&
        $(".initLogin").has(e.target).length == 0 &&
        $(".userInfo").has(e.target).length == 0 &&
        !$(".userInfo").is(e.target) &&
        $(".mars-header__menu-trigger").has(e.target).length == 0 &&
        !$(".mars-header__menu-trigger").is(e.target)
      ) {
        $(".userLoggedinPane").removeClass('active');
        $(".site-header__userRelatedMeta, .mars-header__util").removeClass('active');
        $(".userInfo").removeClass('open');
        $('body').removeClass("body-no-scroll");
        $('.popupModal__mask').fadeOut("fast", function () {
          $('.popupModal__mask').remove();
        });
      }
    }.bind(this));
  }

}

export default OverlayMenu;